<template>
  <div>
    <div v-if="order.admin_notes" class="small">管理员: <span class="text-danger">{{ order.admin_notes }}</span></div>
    <div v-if="order.user_notes" class="small">用户: <span class="text-danger">{{ order.user_notes }}</span></div>
    <div v-if="order.extra_items.length" class="small">
      <div v-for="(item, index) in order.extra_items">
        附件{{index + 1}} : <span class="text-danger">{{item.name}} X {{item.count}}</span>
      </div>
    </div>
    <div v-if="showShipCompany">
      <div class="small">{{getShipCompanyDisplay(order.ship_company)}}
        <ship-company :ship-company="order.ship_company" :ship-no="order.ship_no"></ship-company>
      </div>
      <div class="small" v-if="order.ship_no">
        
        <div v-if="delivery && delivery.status">
          (
          <a href="#" :id="order.ship_no">{{getDeliveryStatusDisplay(delivery.status)}}</a>
          更新于
          <local-time :time="delivery.updated_at"></local-time>
          )

           <b-popover 
            :target="order.ship_no"
            triggers="hover focus"
            placement="top"
            :content="displayDeliveryHistory(delivery.records)">
          </b-popover>
        </div>
      </div>
    </div>
    <div v-if="showAddress" class="small">
      <div>{{order.consignee_address}}</div>
    </div>
  </div>
</template>

<script>
import OrderMixin from '@/mixins/order'
import LocalTime from '@/components/_small/LocalTime'
import ShipCompany from '@/components/_small/ShipCompany'

function displayDeliveryHistory (records) {
  if (!records || records.length === 0) {
    return '没有走件信息'
  }

  let messages = []
  for (let i in records) {
    messages.push(records[i].AcceptTime + ': ' + records[i].AcceptStation)
  }
  return messages.join('\n')
}

export default {
  name: 'orders_extra',
  components: {
    ShipCompany,
    LocalTime
  },
  props: ['order', 'showShipCompany', 'showAddress', 'delivery'],
  methods: {
    displayDeliveryHistory
  },
  mixins: [OrderMixin]
}
</script>